'use strict';

module.exports = function(name, value, opt_time) {
  var date = new Date(+new Date() + (opt_time || 31536000000));
  document.cookie = [
    name +'=' + value,
    'expires=' + date.toUTCString(),
    'path=/'
  ].join('; ');
};



//////////////////
// WEBPACK FOOTER
// ./lib/cookies/set.js
// module id = 10
// module chunks = 1 3